"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidValuesHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _propTypes2 = require("../propTypes");

var _operators = require("../enums/operators");

var _range = require("../mappers/range");

var _options = require("../enums/options");

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var generateAttributeValuesText = function generateAttributeValuesText(attributeValues) {
  return attributeValues.map(function (attributeValue) {
    var valueText;

    switch (attributeValue.type) {
      case _options.RANGE:
        valueText = (0, _range.mapRangeToText)(attributeValue.range);
        break;

      case _options.VALUE:
        valueText = attributeValue.value;
        break;

      case _operators.FORMULA:
        valueText = attributeValue.formula;
        break;

      default:
        valueText = '';
        break;
    }

    return valueText;
  }).join(', ');
};

var ValidValuesHeader = function ValidValuesHeader(_ref) {
  var attribute = _ref.attribute;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-muted"
    }, formatMessage(_messages["default"].validValuesHeader, {
      attribute: attribute.name
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      "data-testid": "ValidValues"
    }, generateAttributeValuesText(attribute.values)))
  );
};

exports.ValidValuesHeader = ValidValuesHeader;
ValidValuesHeader.propTypes = {
  attribute: _propTypes["default"].shape(_propTypes2.atttributeShape).isRequired
};